import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import InitialsAvatar from "@/components/base/InitialsAvatar";
import { getFeaturedTopics, getReviewsByTopic, getWorkById } from "@/utils/content";

export default function ReviewsSection() {
  const topics = getFeaturedTopics(3);
  const spotlight = topics[0];
  const spotlightReviews = getReviewsByTopic(spotlight.id).slice(0, 4);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="Editorial"
          title="深度影评 · 编辑精选"
          subtitle="有观点、有依据的观影参考，帮你在买票之前先读懂一部作品。"
          moreLink={`/review/topic/${spotlight.id}`}
          moreText="进入专题"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Link
            to={`/review/topic/${spotlight.id}`}
            className="group relative block cursor-pointer overflow-hidden rounded-lg"
          >
            <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
              <img
                src={spotlight.cover}
                alt={spotlight.title}
                title={`${spotlight.title} 影评专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/40 to-transparent" />
            </div>
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-primary-950">
                <i className="ri-book-open-line" />
                专题推荐
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">{spotlight.title}</h3>
              <p className="mt-2 line-clamp-2 max-w-xl text-sm leading-relaxed text-background-200">
                {spotlight.intro}
              </p>
            </div>
          </Link>

          <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {spotlightReviews.map((review) => {
              const work = getWorkById(review.workId);
              return (
                <Link
                  key={review.id}
                  to={`/review/topic/${review.topicId}`}
                  className="group flex cursor-pointer gap-4 p-5 transition-colors hover:bg-background-100 md:p-6"
                >
                  <InitialsAvatar name={review.author} size={44} className="bg-accent-100 text-accent-700" />
                  <div className="min-w-0 flex-1">
                    <h4 className="line-clamp-1 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                      {review.title}
                    </h4>
                    <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{review.excerpt}</p>
                    <div className="mt-2.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span className="font-medium text-accent-700">{review.author}</span>
                      {work && <span>· {work.title}</span>}
                      <span>· {review.date}</span>
                      <span>· 阅读约 {review.readTime} 分钟</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {topics.slice(1).map((topic) => (
            <Link
              key={topic.id}
              to={`/review/topic/${topic.id}`}
              className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="relative h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img src={topic.cover} alt={topic.title} title={topic.title} className="h-full w-full object-cover object-top" />
              </div>
              <div className="min-w-0">
                <h4 className="line-clamp-1 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                  {topic.title}
                </h4>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{topic.intro}</p>
              </div>
              <i className="ri-arrow-right-line ml-auto shrink-0 text-foreground-400 transition-transform group-hover:translate-x-1" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}